export default "__VITE_ASSET__BtCeEMWd__"